export const getImmersiveTripId = (state: App.State) =>
  state.tripPlanner.currentTripId
